/**
 * Lookup a single field by MARC tag. Returns `null` if the catalog hasn't
 * loaded yet (or failed to load), or the tag is not in the catalog
 * (custom / extension tags). Consumers must handle null as "no
 * restriction" — the IndicatorEditor falls back to the user-defined
 * options array in that case.
 */
export var getMarcField = function (catalog, tag) { var _a; return ((_a = catalog === null || catalog === void 0 ? void 0 : catalog.fields[tag]) !== null && _a !== void 0 ? _a : null); };
/**
 * Allowed indicator values for a given tag + position. Returns null if the
 * catalog hasn't loaded yet, the tag is not in the catalog, OR the catalog
 * defines no restriction for that indicator position (caller should fall
 * back to user options).
 *
 * `allowed` is the validation-authoritative value set (and may legitimately
 * include a blank `' '` value) and is preferred over `options`, which is a
 * display picker orthogonal to validation — see marc-catalog.schema.json /
 * ADR-0006. Falling back to `options` keeps behaviour sane for any field
 * that only defines a picker without an explicit `allowed` list. An empty
 * `allowed` array is treated the same as an absent one (falls through to
 * `options`/null) rather than as "zero values allowed" — a catalog entry
 * that erroneously ships `allowed: []` must not lock the editor into an
 * unusable empty dropdown with "add option" permanently disabled. A
 * single blank value (`allowed: [' ']`) has length 1 and is unaffected.
 */
export var getAllowedIndicatorValues = function (catalog, tag, which) {
    var _a, _b, _c;
    var field = getMarcField(catalog, tag);
    if (!(field === null || field === void 0 ? void 0 : field.indicators))
        return null;
    var ind = which === 1 ? field.indicators.ind1 : field.indicators.ind2;
    if (!ind)
        return null;
    return ((_a = ind.allowed) === null || _a === void 0 ? void 0 : _a.length) ? ind.allowed : (_c = (_b = ind.options) === null || _b === void 0 ? void 0 : _b.map(function (opt) { return opt.value; })) !== null && _c !== void 0 ? _c : null;
};
/**
 * Lookup a single subfield of a tag by code (CZNA-566). `subfields` is an
 * ARRAY in the catalog, not a map, so this searches by `code` — the same
 * index `FormConfigCompiler.indexCatalogSubfields` builds on the server.
 * Returns `null` while the catalog is loading, for a tag the catalog doesn't
 * know, and for a code the catalog doesn't list under that tag (`400$c`).
 */
export var getMarcSubfield = function (catalog, tag, code) {
    var _a, _b, _c;
    return ((_c = (_b = (_a = getMarcField(catalog, tag)) === null || _a === void 0 ? void 0 : _a.subfields) === null || _b === void 0 ? void 0 : _b.find(function (sf) { return sf.code === code; })) !== null && _c !== void 0 ? _c : null);
};
